import { css } from '@emotion/react';
import styled from '@emotion/styled';

import type { StyledFlexItemProps } from './types';

export const StyledFlexItem = styled.div<StyledFlexItemProps>`
  ${({ $flex }) =>
    $flex != null &&
    css`
      flex: ${$flex};
    `}

  ${({ $grow }) =>
    $grow != null &&
    css`
      flex-grow: ${$grow};
    `}

  ${({ $shrink }) =>
    $shrink != null &&
    css`
      flex-shrink: ${$shrink};
    `}

  ${({ $basis }) =>
    $basis != null &&
    css`
      flex-basis: ${typeof $basis === 'number' ? `${$basis}px` : $basis};
    `}

  ${({ $order }) =>
    $order != null &&
    css`
      order: ${$order};
    `}

  ${({ $alignSelf }) =>
    $alignSelf != null &&
    css`
      align-self: ${$alignSelf};
    `}

  ${({ $maxWidth }) =>
    $maxWidth != null &&
    css`
      max-width: ${$maxWidth};
    `}
`;